import React from 'react'
import { NavLink } from 'react-router-dom'
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import axios from 'axios';
import { Link } from 'react-router-dom';
function Drivers() {
    const [drivers, setDrivers] = React.useState([]);
    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL+'/api/Drivers/GetDrivers')
            .then((response) => {
                setDrivers(response.data);
            }
            )
            .catch((error) => {
                console.log(error);
            })
    }
    , [])
  return (
    <>
        <div className=" rounded flex justify-center flex-col">
    <div className="h-10 m-0 p-0 bg-slate-500 opacity-30 flex justify-between" style={{borderRadius:'4px'}}>
          <input type="text" className=" m-2" style={{borderRadius: '4px'}} placeholder="Search"/>
          
        </div>

        <div className='flex justify-between m-3'>
    <h1 className="text-2xl font-semibold text-gray-900 ">Drivers</h1>
    <NavLink to="/Drivers/adddriver">
            <button
                type="button"
                className="rounded-md bg-lime-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-lime-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                >
                Add Driver
            </button>
            </NavLink>
    </div>
    <div className="overflow-auto relative right-0">

    <table className="  m-2 min-w-full ">
  <thead className="bg-gray-150">
    <tr>
        <th className="px-2 py-3 text-center text-xs font-medium  uppercase tracking-wider border">
            ID
        </th>
        <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
            Driver Name
            </th>
        <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
            DOB
            </th>
        <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
            Licence Number
            </th>
            <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                Date of Issue
            </th>
            <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                Date of Expiry
            </th>
            <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                Address
            </th>
            <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                Contact Number
            </th>
            <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                Experience
            </th>
        <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
            is Active
        </th> 
            <th className=" py-3 text-center text-xs font-medium  uppercase tracking-wider border">
                Actions
            </th>
    </tr>
  </thead>
  <tbody className="bg-white">
    {
        drivers.map((driver) => {
            return (
                <tr key={driver.id}>
                    <td className=" py-4  border text-center"> 
                        {driver.id}
                    </td>
                    <td className=" py-4  border text-center">
                        {driver.driverName}
                    </td>
                    <td className=" py-4  border text-center">
                        {driver.dob}
                    </td>
                    <td className=" py-4  border text-center">
                        {driver.licenseNumber}
                    </td>
                    <td className=" py-4  border text-center">
                        {driver.issueDate}
                    </td>
                    <td className=" py-4  border text-center">
                        {driver.expiryDate}
                    </td>
                    <td className=" py-4  border text-center">
                        {driver.address}
                    </td>
                    <td className=" py-4  border text-center">
                        {driver.contact}
                    </td>
                    <td className=" py-4  border text-center">
                        {driver.exp}
                    </td>
                    <td className=" py-4  border text-center">
                        {driver.isactive ? 'Yes' : 'No'}
                    </td>
                    <td className=" py-4  border text-center ">
                        <Link
                            type="button"
                            className="rounded-md bg-lime-500 ml-2 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-lime-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                            to={`/drivers/editdriver/${driver.id}`}
                            >
                        <FaEdit/>
                        </Link>
                        <Link
                            type="button"
                            className="rounded-md bg-red-500 ml-2 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                            to={`/drivers/deletedriver/${driver.id}`}
                            >
                            <MdDelete/>
                        </Link>
                    </td>
                </tr>
            )
        })
    }
    
  </tbody>
</table>
                    </div>
</div>
        
    </>
  )
}

export default Drivers